// removed by extract-text-webpack-plugin
module.exports = {"overlay":"fGuFbWyuPqYR5kIvB_dnL","wrap":"ndtt09t7Zr599X0_kq3JG","preloader":"_2nMt6iZ1oFJzMi6UMk9NdJ","label":"_2aUIkK7CNR5fS2wl6A9Zn0"};


//////////////////
// WEBPACK FOOTER
// ./src/EpicMigration/components/EpicLoginRedirectSensitiveOverlay.scss
// module id = 2877
// module chunks = 0